import { Image, Text } from '@mantine/core';

const HARD_CODED_EMPTY_CHAT_SUGGESTED_QUESTIONS = [
  {
    question_text: 'I have a question to ask',
    image_url: undefined,
  },
  {
    question_text: 'Help me answer this question',
    image_url: undefined,
  },
  {
    question_text: 'I will explore on my own',
    image_url: undefined,
  },
];

interface EmptyChatComponentProps {
  username: string;
  sendMessage: (message: string, read_url: string | undefined) => void;
}

export const EmptyChatComponent = ({
  username,
  sendMessage,
}: EmptyChatComponentProps) => {
  return (
    <div className="flex justify-center h-[100%] items-center">
      <div className="flex flex-col items-center justify-center">
        <Image
          src={'/icons/favicon.png'}
          mah={80}
          maw={80}
          className="self-center"
        />
        <Text className="text-primary font-bold text-xxl">
          Hi {username || 'there'}!
        </Text>

        <div className="search-prompt-step flex flex-col gap-4 my-8  w-full lg:w-[500px]">
          {HARD_CODED_EMPTY_CHAT_SUGGESTED_QUESTIONS.map((item, index) => (
            <div
              key={index}
              onClick={() => {
                sendMessage(item.question_text, undefined);
              }}
              className="flex items-center justify-center px-10 py-3 bg-white border border-gray-200 hover:border-gray-400 rounded-3xl cursor-pointer"
            >
              <Text className="text-md font-semibold text-gray-400">
                {item.question_text}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
